/*** bundle-builder - Section Scripts ***/
(function () {
  const DEBUG = false;

  const toImageSize = function (url, size) {
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, `_${size}$1$2`);
  };

  const capitalize = function (str = '') {
    const lowStr = str.toLowerCase();
    return lowStr.charAt(0).toUpperCase() + lowStr.slice(1);
  };

  const MQ_MOBILE_ONLY = window.matchMedia('(max-width: 990px)');
  const MQ_DESKTOP_ONLY = window.matchMedia('(min-width: 991px)');

  class SnackbarStack extends HTMLElement {
    constructor() {
      super();

      this.maxVisible = 3;
      this.duration = 3000;

      this.queue = [];
      this.active = [];

      this.isEnabled = MQ_DESKTOP_ONLY.matches;
      this.keepEnabledTypes = ['max-bundle'];
      this._onMediaChange = this._onMediaChange.bind(this);
    }

    connectedCallback() {
      // A11y: announce messages
      this.setAttribute('aria-live', 'polite');
      this.setAttribute('aria-atomic', 'true');

      MQ_DESKTOP_ONLY.addEventListener('change', this._onMediaChange);
    }

    disconnectedCallback() {
      MQ_DESKTOP_ONLY.removeEventListener('change', this._onMediaChange);
      this._clearAll();
    }

    _onMediaChange(e) {
      this.isEnabled = e.matches;

      if (!this.isEnabled) {
        this._clearAll();
      }
    }

    _clearAll() {
      this.active.forEach((s) => s.el.remove());
      this.active = [];
    }

    setupMessage(item, type) {
      if (!this.isEnabled && !this.keepEnabledTypes.includes(type)) return;

      const messageTemplate = this.getAttribute(`data-bb-snackbar-label-${type}`);
      if (!messageTemplate) {
        if (DEBUG) console.log(`SnackbarStack: No message template found for type ${type}, exiting...`);
        return;
      }

      let message = `<div class="snackbar__message">${messageTemplate}</div>`;

      if (item) {
        const title = capitalize(item?.data?.title || item?.title);
        const quantity = item.quantity;
        const image = `<div class="snackbar__image"><img src="${item.image}" alt="${title}"/></div>`;

        message =
          image +
          messageTemplate
            .replace('${p_name}', `<span class="color--accent">${title}</span>`)
            .replace('${quantity}', quantity);
      }

      return message;
    }

    show(message, options = {}) {
      if (!this.isEnabled && !this.keepEnabledTypes.includes(options.type)) return;

      const snackbar = {
        id: crypto.randomUUID(),
        message,
        type: options.type || 'info',
        duration: options.duration ?? this.duration,
      };

      // If max visible reached, dismiss the oldest
      if (this.active.length >= this.maxVisible) {
        const oldest = this.active[0];
        this.#dismiss(oldest.id);
      }

      // Render new snackbar immediately
      this.#render(snackbar);
    }

    #render(snackbar) {
      if (!this.isEnabled && !this.keepEnabledTypes.includes(snackbar.type)) return;

      const el = document.createElement('div');
      el.classList.add('snackbar');
      el.dataset.type = snackbar.type;

      el.innerHTML = snackbar.message;

      // Create dismiss button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'snackbar__close';
      closeBtn.setAttribute('aria-label', 'Dismiss');
      closeBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19.7081 18.2931C19.801 18.386 19.8747 18.4963 19.9249 18.6177C19.9752 18.7391 20.0011 18.8692 20.0011 19.0006C20.0011 19.132 19.9752 19.2621 19.9249 19.3835C19.8747 19.5048 19.801 19.6151 19.7081 19.7081C19.6151 19.801 19.5048 19.8747 19.3835 19.9249C19.2621 19.9752 19.132 20.0011 19.0006 20.0011C18.8692 20.0011 18.7391 19.9752 18.6177 19.9249C18.4963 19.8747 18.386 19.801 18.2931 19.7081L10.0006 11.4143L1.70806 19.7081C1.52042 19.8957 1.26592 20.0011 1.00056 20.0011C0.735192 20.0011 0.480697 19.8957 0.293056 19.7081C0.105415 19.5204 5.23096e-09 19.2659 0 19.0006C-5.23096e-09 18.7352 0.105415 18.4807 0.293056 18.2931L8.58681 10.0006L0.293056 1.70806C0.105415 1.52042 0 1.26592 0 1.00056C0 0.735192 0.105415 0.480697 0.293056 0.293056C0.480697 0.105415 0.735192 0 1.00056 0C1.26592 0 1.52042 0.105415 1.70806 0.293056L10.0006 8.58681L18.2931 0.293056C18.4807 0.105415 18.7352 -5.23096e-09 19.0006 0C19.2659 5.23096e-09 19.5204 0.105415 19.7081 0.293056C19.8957 0.480697 20.0011 0.735192 20.0011 1.00056C20.0011 1.26592 19.8957 1.52042 19.7081 1.70806L11.4143 10.0006L19.7081 18.2931Z" fill="white"/>
                            </svg>`;

      el.appendChild(closeBtn);

      this.appendChild(el);
      this.active.push({ ...snackbar, el });

      // If duration is Infinity, skip auto-dismiss (user must close manually)
      let timeout;
      if (Number.isFinite(snackbar.duration)) {
        timeout = setTimeout(() => {
          this.#dismiss(snackbar.id);
        }, snackbar.duration);
      }

      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // prevent triggering the el click handler
        clearTimeout(timeout);
        this.#dismiss(snackbar.id);
      });
    }

    #dismiss(id) {
      const index = this.active.findIndex((s) => s.id === id);
      if (index === -1) return;

      const snackbar = this.active[index];
      this.active.splice(index, 1);

      const el = snackbar.el;
      if (!el || !el.isConnected) return;

      const removeEl = () => {
        if (!el.isConnected) return;
        el.remove();
      };

      el.classList.add('exit');

      const cs = window.getComputedStyle(el);
      const parseTimeList = (v) =>
        String(v || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
          .map((s) => {
            const n = parseFloat(s);
            if (!Number.isFinite(n)) return 0;
            return s.endsWith('ms') ? n : n * 1000;
          });

      const ad = parseTimeList(cs.animationDuration);
      const adel = parseTimeList(cs.animationDelay);
      const td = parseTimeList(cs.transitionDuration);
      const tdel = parseTimeList(cs.transitionDelay);

      const max = (arr) => (arr && arr.length ? Math.max(...arr) : 0);

      const animationMs = max(ad) + max(adel);
      const transitionMs = max(td) + max(tdel);
      const fallbackMs = Math.max(animationMs, transitionMs);

      let removed = false;
      const done = () => {
        if (removed) return;
        removed = true;
        removeEl();
      };

      el.addEventListener('animationend', done, { once: true });
      el.addEventListener('transitionend', done, { once: true });

      if (fallbackMs > 0) {
        setTimeout(done, fallbackMs + 100);
      } else {
        requestAnimationFrame(done);
      }
    }
  }

  customElements.define('snackbar-stack', SnackbarStack);

  class BundleBuilder extends HTMLElement {
    constructor() {
      super();

      this.isMobile = MQ_MOBILE_ONLY.matches;

      this.products = [];
      this.CARD_TEMPLATE = this.querySelector('#bundle-builder__cart-card-template');
      this.PRODUCT_GRID = this.querySelector('[data-bb-products-grid]');
      this.CART_ELEMENT = this.querySelector('#bundle-builder__cart');
      this.CART_TRIGGER = this.querySelector('#bundle-builder__cart-trigger');
      this.CART_WIDGET = this.querySelector('#bundle-builder__cart-widget');
      this.CART_WIDGET_CARD_TEMPLATE = this.querySelector('#bundle-builder__cart-widget-card-template');
      this.CART_SUBMIT_BUTTON = this.CART_ELEMENT.querySelector('#bundle-builder__cart-submit');
      this.FLUSH_BUTTON = this.CART_ELEMENT.querySelector('#bundle-builder__cart-clear');
      this.CART_WIDGET_SUBMIT_BUTTON = this.querySelector('#bundle-builder__cart-widget-submit');
      this.CART_CLOSE_TRIGGER = this.querySelector('#bundle-builder__cart-close');
      this.MIN_PROD = parseInt(this.getAttribute('data-bb-min-products') || 1);
      this.MAX_PROD = parseInt(this.getAttribute('data-bb-max-products') || 0);
      this.SNACKBAR_STACK = this.querySelector('snackbar-stack');
      this.CART_INTERACTIONS = 0;

      this.CART_STICKY_OPTIONS = {};

      this.LABEL_TEMPLATE = this.querySelector('#bundle-builder__promo-label');

      if (!this.CART_ELEMENT) {
        console.error('BB - constructor(): Could not find cart!');
        window.alert(
          'Something went wrong while building the page! Please refresh the page and try again or contact customer care at ...',
        );
        return;
      }

      this.SKELETONS_CACHE = this.saveSkeletonsCache();
      this.MAX_SKELETONS_NUMBER = this.CART_ELEMENT.querySelectorAll(`[data-bb-product-skeleton-order]`).length;

      this._onMediaChange = this._onMediaChange.bind(this);

      /*
      COMPULSORY FIELDS STRUCTURE:
        _cartItems = {
        `${itemIndex}_${item.id}` : {
            variant_id: 12345,
            quantity: 1,
            image: 'https://example.com/image.jpg',
            bundle_order: 1
          }
        }
      */
      this._cartItems = {};
      this._productDataCache = {}; // Cache product data to avoid re-fetching
      this._stepsCache = null; // Cache step elements for updateProductGridUI

      this.init();
    }

    connectedCallback() {
      if (DEBUG) console.log('BB - Bundle builder element connected');

      MQ_MOBILE_ONLY.addEventListener('change', this._onMediaChange);
      // Promo pills observer/UI removed
      this.setupCartWidgetItemLabelsObserver();
      this.syncCartWidgetItemPromoLabels();
    }

    disconnectedCallback() {
      if (DEBUG) console.log('BB - Bundle builder element disconnected');

      MQ_MOBILE_ONLY.removeEventListener('change', this._onMediaChange);
      // Promo pills observer cleanup removed
      this._cartWidgetItemLabelsObserver?.disconnect();
      this._cartWidgetItemLabelsObserver = null;
    }

    setupCartWidgetItemLabelsObserver() {
      if (this._cartWidgetItemLabelsObserver || !this.CART_ELEMENT) return;

      const source = this.CART_ELEMENT.querySelector('.bundle-builder__cart-products');
      if (!source) return;

      this._cartWidgetItemLabelsObserver = new MutationObserver(() => {
        this.syncCartWidgetItemPromoLabels();
      });

      this._cartWidgetItemLabelsObserver.observe(source, {
        childList: true,
        subtree: true,
      });
    }

    syncCartWidgetItemPromoLabels() {
      const widgetList = this.CART_WIDGET?.querySelector('.bundle-builder__cart-products');
      const sourceList = this.CART_ELEMENT?.querySelector('.bundle-builder__cart-products');
      if (!widgetList) return;

      const createLabel = (text) => {
        if (!this.LABEL_TEMPLATE) return null;
        const frag = this.LABEL_TEMPLATE.content.cloneNode(true);
        const el = frag.querySelector('.bundle-builder__promo-label-item');
        const span = frag.querySelector('[data-bb-promo-label]');
        if (span) span.textContent = text;
        return el;
      };

      const getTierLabelForExactCount = (count) => {
        if (!window.SF_BUNDLE_TIERS) return '';

        const tier = window.SF_BUNDLE_TIERS[count];
        if (!tier) return '';

        const label = String(tier.label || '').trim();
        if (label) return label;

        const type = String(tier.type || '').trim();
        if (type === 'free_gift') return 'Omaggio';

        const pct = Number(tier.discount_percentage);
        if (Number.isFinite(pct) && pct > 0) return `${pct}% OFF`;

        return '';
      };

      const sourceItems = sourceList
        ? Array.from(sourceList.children).filter((li) => li?.matches?.('.bundle-builder__cart-item'))
        : [];

      const widgetSlots = Array.from(widgetList.children).filter((li) =>
        li?.matches?.('.bundle-builder__cart-item, .bundle-builder__cart-card--skeleton'),
      );

      // Always clear existing labels in the widget (both skeletons and real items)
      widgetSlots.forEach((li) => {
        li.querySelector('.bundle-builder__promo-label-item')?.remove();
      });

      // 1) Mirror labels from the real cart items (when present)
      const widgetItems = widgetSlots.filter((li) => li?.matches?.('.bundle-builder__cart-item'));

      widgetItems.forEach((wli, idx) => {
        const sli = sourceItems[idx];
        const label = sli?.querySelector?.('.bundle-builder__promo-label-item');
        if (label) {
          wli.appendChild(label.cloneNode(true));
        }
      });

      // 2) Fill missing labels:
      //    - For skeletons: use the tier label that corresponds to their skeleton order
      //    - For real items without a mirrored label: use their slot index (bundle order)
      widgetSlots.forEach((li, idx) => {
        if (li.querySelector('.bundle-builder__promo-label-item')) return;

        const skeletonOrderAttr = li.getAttribute('data-bb-product-skeleton-order');
        const slotOrder = skeletonOrderAttr ? parseInt(skeletonOrderAttr, 10) : idx + 1;
        if (!Number.isFinite(slotOrder) || slotOrder <= 0) return;

        const text = getTierLabelForExactCount(slotOrder);
        if (!text) return;

        const labelEl = createLabel(text);
        if (!labelEl) return;

        li.appendChild(labelEl);
      });
    }

    adoptedCallback() {
      if (DEBUG) console.log('BB - Bundle builder element adopted');
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (DEBUG) console.log(`Bundle builder element attributeChanged: ${name} ${oldValue} -> ${newValue}`);
    }

    startLoading() {
      this.classList.add('loading');
    }

    stopLoading() {
      this.classList.remove('loading');
    }

    startLoadingOnElement(element) {
      element.classList.add('loading');
    }

    stopLoadingOnElement(element) {
      element.classList.remove('loading');
    }

    _onMediaChange(e) {
      this.isMobile = e.matches;

      if (!this.isMobile) {
        document.documentElement.classList.remove('bundle-builder__cart--open');
      }

      this.addStyleForWidget();
      this.setupMobileListeners();
    }

    addStyleForWidget() {
      if (!this.CART_WIDGET) {
        if (DEBUG) console.log('BB - addStyleForWidget(): Could not find cart widget!');
        return;
      }

      document.body.style.setProperty('--cart-widget-height', this.CART_WIDGET.offsetHeight + 'px');
    }

    // Mobile only method
    setupMobileListeners() {
      this.CART_TRIGGER.removeEventListener('click', this.toggleCart.bind(this));
      this.CART_CLOSE_TRIGGER.removeEventListener('click', this.toggleCart.bind(this));

      if (this.isMobile) {
        if (this.CART_TRIGGER) {
          this.CART_TRIGGER.addEventListener('click', this.toggleCart.bind(this));
          this.CART_CLOSE_TRIGGER.addEventListener('click', this.toggleCart.bind(this));
        }
      }
    }

    // Mobile only method
    toggleCart() {
      if (document.documentElement.classList.contains('bundle-builder__cart--open')) {
        document.documentElement.classList.remove('bundle-builder__cart--open');
      } else {
        document.documentElement.classList.add('bundle-builder__cart--open');
      }
    }

    getNextSiblingsBySelector(elem, selector) {
      const siblings = [];
      let next = elem.nextElementSibling;
      while (next) {
        if (next.matches(selector)) {
          siblings.push(next);
        }
        next = next.nextElementSibling;
      }
      return siblings;
    }

    saveSkeletonsCache() {
      const skeletonsOnLoad = this.CART_ELEMENT.querySelectorAll(`[data-bb-product-skeleton-order]`);
      const skeletonCache = {};

      if (!skeletonsOnLoad?.length) {
        if (DEBUG) console.error('BB - saveSkeletonsCache():', 'No skeletons found!');
        return {};
      }

      skeletonsOnLoad.forEach((skeleton) => {
        const skeletonOrder = skeleton.getAttribute('data-bb-product-skeleton-order');
        const skeletonEl = skeleton.cloneNode(true);
        skeletonCache[skeletonOrder] = skeletonEl;
      });

      return skeletonCache;
    }

    filterBundleProductsInCart(itemsInCart) {
      return itemsInCart.filter(function (item) {
        if (!item.properties) return false;

        return !!item.properties['_bundle-builder'] === true && !!item.properties['_bundle-builder-gift'] !== true;
      });
    }

    filterBundleGiftsInCart(itemsInCart) {
      return itemsInCart.filter(function (item) {
        if (!item.properties) return false;

        return !!item.properties['_bundle-builder'] === true && !!item.properties['_bundle-builder-gift'] === true;
      });
    }

    sortBundleProducs(bundleProducts) {
      if (!bundleProducts || !bundleProducts.length) return [];

      return bundleProducts.sort(
        (a, b) => a.properties['_bundle-builder-order'] - b.properties['_bundle-builder-order'],
      );
    }

    countBundleProducts(bundleProductsInCart) {
      return bundleProductsInCart.map((item) => item.quantity).reduce((a, b) => a + b, 0);
    }

    // Verifica il presunto tier attivo in base al numero di prodotti nel bundle (ritorna il tier più basso rispetto al conteggio dei prodotti a carrello se non c'è un match
    findCurrentActiveTier(obj, x) {
      let bestKey = null;
      let bestVal = null;

      for (const k of Object.keys(obj)) {
        const kn = Number(k);
        if (!Number.isFinite(kn)) continue;

        if (kn <= x && (bestKey === null || kn > Number(bestKey))) {
          bestKey = k;
          bestVal = obj[k];
        }
      }

      return bestKey !== null ? { key: bestKey, value: bestVal } : null;
    }

    findCurrentActiveTierByType(type, x) {
      if (!window.SF_BUNDLE_TIERS) return null;

      let bestKey = null;
      let bestVal = null;

      for (const [k, v] of Object.entries(window.SF_BUNDLE_TIERS)) {
        const kn = Number(k);
        if (!Number.isFinite(kn)) continue;
        if (!v || v.type !== type) continue;

        if (kn <= x && (bestKey === null || kn > Number(bestKey))) {
          bestKey = k;
          bestVal = v;
        }
      }

      return bestKey !== null ? { key: bestKey, value: bestVal } : null;
    }

    findActiveTiersByType(type, x) {
      if (!window.SF_BUNDLE_TIERS) return [];

      const tiers = [];

      for (const [k, v] of Object.entries(window.SF_BUNDLE_TIERS)) {
        const kn = Number(k);
        if (!Number.isFinite(kn)) continue;
        if (!v || v.type !== type) continue;
        if (kn > x) continue;

        tiers.push({ key: String(k), value: v });
      }

      tiers.sort((a, b) => Number(a.key) - Number(b.key));
      return tiers;
    }

    getRequiredFreeGiftVariantIds(itemsCount) {
      const giftTiers = this.findActiveTiersByType('free_gift', itemsCount);
      const ids = [];

      giftTiers.forEach((t) => {
        const id = t?.value?.free_gift?.id;
        if (id == null) return;
        const n = Number(id);
        if (!Number.isFinite(n) || n <= 0) return;
        ids.push({ tierKey: t.key, variantId: n });
      });

      const seen = new Set();
      return ids.filter((g) => {
        const k = String(g.variantId);
        if (seen.has(k)) return false;
        seen.add(k);
        return true;
      });
    }

    async flushBundleInShopifyCart(manageLoadingState = true) {
      const _this = this;
      if (manageLoadingState) _this.startLoading();
      return await fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((data) => {
          const bundleProductsInCart = this.filterBundleProductsInCart(data.items);
          const bundleGiftsInCart = this.filterBundleGiftsInCart(data.items);
          const bundleItemsToRemove = [...bundleProductsInCart, ...bundleGiftsInCart];
          return bundleItemsToRemove;
        })
        .then(async (bundleItemsToRemove) => {
          const updates = {};

          bundleItemsToRemove.map((item) => {
            updates[item.key] = 0;
          });

          await fetch(`${routes.cart_update_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates,
              attributes: {
                '_bundle-counter': null,
              },
            }),
          }).catch((error) => {
            console.error('BB - flushBundleInShopifyCart():', error);
            window.alert(
              'Something went wrong while processing your bundle! Please refresh the page and try again or contact customer care at ...',
            );

            _this.stopLoading();
          });

          const productCards = _this.querySelectorAll('.bundle-builder__products [data-bb-product-id]');
          productCards.forEach((card) => {
            _this.updateProductLimit(card, -1);
          });

          if (manageLoadingState) {
            _this.stopLoading();
            this.PRODUCT_GRID.removeAttribute('disabled');
          }
        });
    }

    async addBundleToCart(options = {}) {
      const _this = this;
      this.startLoading();
      if (DEBUG) console.log('BB - BEFORE ADD TO CART');

      await this.flushBundleInShopifyCart(false);
      const internalCartItemsMap = this.getInternalCartItemsMap();
      const bundleItemsCount = internalCartItemsMap.length;
      const requiredFreeGifts = this.getRequiredFreeGiftVariantIds(bundleItemsCount);

      if (DEBUG) console.log('BB - addBundleToCart(): bundleItemsCount', bundleItemsCount);
      if (DEBUG) console.log('BB - addBundleToCart(): requiredFreeGifts', requiredFreeGifts);

      const newBundleCartItems = internalCartItemsMap.map(([itemId, item]) => {
        const properties = {
          '_bundle-builder': true,
          '_bundle-builder-order': item['bundle_order'],
        };

        return {
          id: item.variant_id,
          quantity: item.quantity,
          properties,
        };
      });

      if (requiredFreeGifts.length) {
        requiredFreeGifts.forEach((g) => {
          newBundleCartItems.push({
            id: g.variantId,
            quantity: 1,
            properties: {
              '_bundle-builder': true,
              '_bundle-builder-gift': true,
              '_bundle-builder-gift-tier': g.tierKey,
            },
          });
        });
      }

      await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: newBundleCartItems }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (DEBUG) console.log('BB - ADD TO CART RESPONSE', data);
          return data;
        })
        .then(async (data) => {
          if (data?.items?.length > 0) {
            return await _this.updateBundleTier(data);
          }
        })
        .catch((error) => {
          console.error('BB - addBundleToCart():', error);
          window.alert(
            'Something went wrong while processing your bundle! Please refresh the page and try again or contact customer care at ...',
          );
        });

      if (DEBUG) console.log('BB - AFTER ADD TO CART');

      // GOING TO CHECKOUT (only when manually submitted, not when max bundle is auto-reached)
      if (!options?.maxBundleReached) {
        window.setTimeout(() => {
          window.location.href = Shopify.routes.root + 'checkout';
          this.stopLoading();
        }, 0);
      } else {
        this.stopLoading();
      }
    }

    async updateBundleTier(cartContents) {
      const bundleProducts = this.filterBundleProductsInCart(cartContents.items);
      const bundleGifts = this.filterBundleGiftsInCart(cartContents.items);

      if (DEBUG) console.log('BB - updateBundleTier(): BUNDLE GIFTS', bundleGifts);

      const bundleProductsCount = this.countBundleProducts(bundleProducts);
      let currentTierNeedsFreeGift = false;
      const updates = {};

      if (DEBUG) console.log('BB - updateBundleTier(): CART CONTENTS', cartContents);

      if (!window.SF_BUNDLE_TIERS) return;

      if (DEBUG) console.log('BB - updateBundleTier(): BUNDLE TIERS DEFINED', window.SF_BUNDLE_TIERS);

      const presumedTier = this.findCurrentActiveTier(window.SF_BUNDLE_TIERS, bundleProductsCount);
      if (presumedTier) if (DEBUG) console.log('BB - updateBundleTier(): CURRENT BUNDLE TIER FOUND: ', presumedTier);

      const requiredFreeGifts = this.getRequiredFreeGiftVariantIds(bundleProductsCount);
      const requiredGiftIdsSet = new Set(requiredFreeGifts.map((g) => String(g.variantId)));

      if (DEBUG) console.log('BB - updateBundleTier(): requiredFreeGifts', requiredFreeGifts);

      const giftsToRemove = bundleGifts.filter((gift) => {
        const vid = String(gift?.variant_id ?? gift?.id ?? '');
        if (!vid) return true;
        return !requiredGiftIdsSet.has(vid);
      });

      giftsToRemove.forEach((gift) => {
        updates[gift.key] = 0;
      });

      const giftsInCartIdsSet = new Set(bundleGifts.map((g) => String(g?.variant_id ?? g?.id ?? '')).filter(Boolean));

      const giftsToAdd = requiredFreeGifts.filter((g) => !giftsInCartIdsSet.has(String(g.variantId)));
      if (giftsToAdd.length) currentTierNeedsFreeGift = true;

      if (DEBUG) console.log('Free bundle gifts in cart: ', bundleGifts);
      if (DEBUG) console.log('Free gifts required: ', requiredFreeGifts);
      if (DEBUG) console.log('Free gifts to remove: ', giftsToRemove);
      if (DEBUG) console.log('Free gifts to add: ', giftsToAdd);

      // Remove bundle counter property or set new tier value
      const newBundleAttributes = presumedTier
        ? { '_bundle-counter': presumedTier.value.min_items }
        : { '_bundle-counter': null };

      if (DEBUG)
        console.log({
          updates,
          attributes: newBundleAttributes,
        });

      await fetch(`${routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates,
          attributes: newBundleAttributes,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (DEBUG) console.log('BB - updateBundleStatus(): UPDATES RESULTS:', data);
        })
        .catch((error) => {
          console.error('BB - updateBundleStatus(): UPDATES ERROR:', error);
          window.alert(
            'Something went wrong while processing your bundle! Please refresh the page and try again or contact customer care at ...',
          );
        });

      if (currentTierNeedsFreeGift) {
        if (!giftsToAdd || !giftsToAdd.length) {
          if (DEBUG) console.log('BB - updateBundleTier(): No gifts to add');
          return;
        }
        await fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: giftsToAdd.map((g) => {
              return {
                id: g.variantId,
                quantity: 1,
                properties: {
                  '_bundle-builder': true,
                  '_bundle-builder-gift': true,
                  '_bundle-builder-gift-tier': g.tierKey,
                },
              };
            }),
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if (DEBUG) console.log('BB - updateBundleStatus(): GIFT ADD RESULTS:', data);
          })
          .catch((error) => {
            console.error('BB - updateBundleStatus(): GIFT ADD ERROR:', error);
            window.alert(
              'Something went wrong while processing your bundle! Please refresh the page and try again or contact customer care at ...',
            );
          });
      }

      if (DEBUG) console.log('BB - BUNDLE PRODUCTS IN CART', bundleProductsCount);
    }

    setBeforeGoingToCheckoutEvent() {
      const _this = this;
      if (!this.CART_SUBMIT_BUTTON) {
        if (DEBUG) console.log('BB - CART SUBMIT BUTTON NOT FOUND');
        return;
      }

      this.CART_WIDGET_SUBMIT_BUTTON.addEventListener('click', () => {
        _this.CART_SUBMIT_BUTTON?.click();
      });
    }

    setupListeners() {
      this.setAddToCartEvent();
      this.setCardQuickBuyClick();
      this.setProxiedAddToCartEvent();
      this.setRemoveFromCartEvent();
      this.setAddBundleToCartEvent();
      this.setBeforeGoingToCheckoutEvent();
      this.setFlushCartEvent();
    }

    /**
     * Updates the limit of a product based on the quantity in the cart.
     * If the quantity of the product in the cart + the diff is greater than or equal to the product limit,
     * the product will be disabled.
     * @param {HTMLElement} product - The product element to update.
     * @param {number} diff - The difference in quantity to apply to the product limit.
     */
    updateProductLimit(product, diff, showSnackbar = true) {
      const _this = this;

      if (!product) {
        console.error('BB - updateProductLimit(): No product passed');
        return;
      }

      const productId = product.getAttribute('data-bb-product-id');
      const productLimit = parseInt(product.getAttribute('data-bb-product-limit'));
      const itemValuesInCart = Object.values(this._cartItems).filter((item) => item.variant_id == productId);
      const currentEvaluatedItem = Object.values(this._cartItems).find((item) => item.variant_id == productId);

      if (itemValuesInCart.length + diff >= productLimit) {
        product.setAttribute('disabled', true);

        if (currentEvaluatedItem && showSnackbar) {
          _this.SNACKBAR_STACK.show(_this.SNACKBAR_STACK.setupMessage(currentEvaluatedItem, 'max'));
        }
      } else {
        product.removeAttribute('disabled');
      }
    }

    setCardQuickBuyClick() {
      const productsContainer = this.querySelector('[data-bb-products]');
      if (!productsContainer) return;

      if (productsContainer.hasAttribute('data-bb-card-quickbuy-bound')) return;
      productsContainer.setAttribute('data-bb-card-quickbuy-bound', '');

      productsContainer.addEventListener('click', (e) => {
        const productCardWrapper = e.target.closest('.product-card-wrapper');
        if (!productCardWrapper || !productsContainer.contains(productCardWrapper)) return;

        const interactive = e.target.closest(
          'button, a, input, select, textarea, label, summary, details, modal-opener, [role="button"], [role="link"]',
        );
        if (interactive) return;

        const productEl = productCardWrapper.closest('[data-bb-product-id]');
        if (!productEl) return;

        if (productEl.hasAttribute('disabled')) {
          const productId = productEl.getAttribute('data-bb-product-id');
          const currentEvaluatedItem = Object.values(this._cartItems || {}).find(
            (item) => String(item?.variant_id) === String(productId),
          );

          if (currentEvaluatedItem) {
            this.SNACKBAR_STACK?.show(this.SNACKBAR_STACK.setupMessage(currentEvaluatedItem, 'max'));
          }

          return;
        }

        const form = productEl.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        const submitBtn = form.querySelector('button[type="submit"], .quick-add__submit');
        if (submitBtn && submitBtn.matches(':disabled,[disabled]')) return;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitBtn || undefined);
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }

    setAddToCartEvent() {
      const _this = this;
      const productsContainer = this.querySelector('[data-bb-products]');
      if (!productsContainer) return;

      // Use event delegation: one listener on the container instead of N on each form
      productsContainer.addEventListener('submit', async (event) => {
        const form = event.target.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;

        event.preventDefault();

        const product = form.closest('[data-bb-product-id]');
        if (!product) return;

        // If product is disabled, don't add to cart
        if (product.getAttribute('disabled')) {
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }

        if (event?.details?.isProxied) {
          _this.startLoadingOnElement(product);
        }

        _this.updateProductLimit(product, 1);

        const formData = new FormData(form);
        const productId = formData.get('id');
        const productUrlElement = form.querySelector('[data-product-url]');

        if (!productId || !productUrlElement) {
          console.error('BB - setupListeners(): No product id found');
          return;
        }

        const productUrl = productUrlElement.getAttribute('data-product-url');

        // Use cached product data if available
        let productData = _this._productDataCache[productUrl];
        if (!productData) {
          productData = await fetch(`${productUrl}.js`)
            .then((response) => response.json())
            .catch((e) => {
              console.error('Error fetching product data', productUrl);
              console.error(e);
              window.alert(
                'Something went wrong while processing your bundle! Please refresh the page and try again or contact customer care at ...',
              );
            });
          if (productData) _this._productDataCache[productUrl] = productData;
        }

        if (!productData) return;

        const itemIndex = _this.getNextItemId();
        const item = {
          variant_id: productId,
          quantity: 1,
          image: productData.featured_image,
          bundle_order: itemIndex,
          data: productData,
        };

        _this.saveItemInCart(item, itemIndex);
        _this.updateCartUI();

        _this.SNACKBAR_STACK.show(_this.SNACKBAR_STACK.setupMessage(item, 'add'));

        _this.updateProductGridUI();
        _this.stopLoadingOnElement(product);
        _this.CART_INTERACTIONS++;
      });
    }

    setProxiedAddToCartEvent() {
      const _this = this;
      const modalsAddToCart = document.querySelectorAll('[data-bb-modal-quick-add]');
      if (modalsAddToCart && modalsAddToCart.length) {
        modalsAddToCart.forEach((modalATC) => {
          modalATC.addEventListener('click', async (event) => {
            event.preventDefault();
            const modalDialog = modalATC.closest('modal-dialog');
            const modalClose = modalDialog.querySelector('.standard-popup-modal__toggle');
            const proxyCardId = modalATC.getAttribute('data-bb-modal-quick-add');
            const proxyCard = _this.querySelector('[data-bb-product-id="' + proxyCardId + '"]');
            const form = proxyCard.querySelector('form[data-type="add-to-cart-form"]');

            if (!form) {
              if (DEBUG) console.error('BB - setProxiedAddToCartEvent(): No form found');
              return;
            }

            form.dispatchEvent(
              new CustomEvent('submit', {
                bubbles: true,
                cancelable: true,
                detail: {
                  isProxied: true,
                },
              }),
            );

            if (!modalDialog) {
              if (DEBUG) console.error('BB - setProxiedAddToCartEvent(): No modal dialog found');
              return;
            }

            if (!modalClose) {
              if (DEBUG) console.error('BB - setProxiedAddToCartEvent(): No modal close button found');
              return;
            }

            modalClose.click();
          });
        });
      }
    }

    setFlushCartEvent() {
      this.FLUSH_BUTTON = this.CART_ELEMENT.querySelector('#bundle-builder__cart-clear') || this.FLUSH_BUTTON;
      const _this = this;

      if (!_this.FLUSH_BUTTON) {
        console.warn('BB - setFlushCartEvent(): Could not find flush button');
        return;
      }

      this.FLUSH_BUTTON.addEventListener('click', async function () {
        _this.flushBundleInShopifyCart();
        _this._cartItems = {};
        // Directly remove 'selected' class from all product cards in the grid
        _this.PRODUCT_GRID.querySelectorAll('[data-bb-product-id].selected').forEach((card) => {
          card.classList.remove('selected');
        });
        // Reset all step counters
        _this.querySelectorAll('[data-bb-step-counter]').forEach((counter) => {
          counter.setAttribute('disabled', true);
          counter.setAttribute('data-bb-step-counter', 0);
        });
        _this.updateCartUI();
        _this.updateProductGridUI();
      });
    }

    setRemoveFromCartEvent() {
      const _this = this;
      if (_this.CART_ELEMENT) {
        // Using event delegation for improved performance and flexibility

        _this.CART_ELEMENT.addEventListener('click', (event) => {
          if (event.target.matches('[data-bb-product-remove]')) {
            const itemToRemove = event.target.closest('[data-bb-product-id]');
            const productInternalId = itemToRemove.getAttribute('data-bb-product-id');
            if (productInternalId && _this._cartItems[productInternalId]) {
              const newCartItems = { ..._this._cartItems };
              const oldEntryObject = newCartItems[productInternalId];
              const productId = oldEntryObject.variant_id;
              delete newCartItems[productInternalId];
              _this.updateSortBundleOrder(Object.values(newCartItems));

              _this.updateCartUI();

              const removedProductCard = _this.querySelector(`[data-bb-product-id="${productId}"]`);
              _this.updateProductLimit(removedProductCard, 0);
              _this.updateProductGridUI();

              _this.CART_INTERACTIONS++;
            }
          }
        });
      }
    }

    setAddBundleToCartEvent() {
      const _this = this;
      const submitButton = document.querySelector('#bundle-builder__cart-submit');
      if (!submitButton) {
        console.error('BB - setaddBundleToCartEvent(): Could not find submit button');
        return;
      }

      submitButton.addEventListener('bundleBuilder:maxReached', function (e) {
        const maxBundleReached = e?.detail?.maxBundleReached;
        _this.addBundleToCart({ maxBundleReached });
      });

      submitButton.addEventListener('click', function () {
        _this.addBundleToCart();
      });
    }

    getBundleBuilderProducts() {
      const productElements = this.querySelectorAll('[data-bb-product-id]');
      if (productElements && productElements.length) {
        this.products = Array.from(productElements);
      }
    }

    getItemId(item, itemIndex) {
      return `${itemIndex}_${item.variant_id}`;
    }

    getNextItemId() {
      const cartItems = Object.values(this._cartItems);
      const cartItemsLength = cartItems.length;

      if (cartItemsLength > 0) {
        return cartItems[cartItemsLength - 1].bundle_order + 1;
      } else {
        return 1;
      }
    }

    updateProductInBundleBuilderCartUI(itemId, item) {
      const cardTemplate = this.CARD_TEMPLATE.content.cloneNode(true);
      cardTemplate.querySelector('[data-bb-product-id]').setAttribute('data-bb-product-id', itemId);
      cardTemplate.querySelector('[data-bb-product-order]').setAttribute('data-bb-product-order', item.bundle_order);

      const imageEl = cardTemplate.querySelector('.bundle-builder__cart-item-image');
      imageEl.src = toImageSize(item.image, '250x250');

      this.CART_ELEMENT.querySelector('.bundle-builder__cart-products').appendChild(cardTemplate);
    }

    updateProductInBundleBuilderWidgetUI(itemId, item) {
      const cardTemplate = this.CART_WIDGET_CARD_TEMPLATE.content.cloneNode(true);

      const imageEl = cardTemplate.querySelector('.bundle-builder__cart-item-image');
      imageEl.src = toImageSize(item.image, '132x132');

      this.CART_WIDGET.querySelector('.bundle-builder__cart-products').appendChild(cardTemplate);
    }

    saveItemInCart(item, itemIndex) {
      if (DEBUG) console.log('BB - saveItemInCart(): SAVING ITEM', item, itemIndex);
      const itemInternalId = this.getItemId(item, itemIndex);
      item['bundle_order'] = itemIndex;
      this._cartItems[itemInternalId] = item;
      if (DEBUG) console.log('BB - saveItemInCart(): AFTER SAVING ITEM', this._cartItems);
    }

    updateSortBundleOrder(itemsList) {
      const sortedItems = itemsList.sort((a, b) => a.bundle_order - b.bundle_order);

      this._cartItems = {};
      this.updateInternalCartItemsMap(sortedItems);

      return this._cartItems;
    }

    updateInternalCartItemsMap(itemsList) {
      if (!itemsList) {
        console.error('BB - updateInternalCartItemsMap():No items passed to update internal mapping');
      }

      if (DEBUG) console.log('BB - updateInternalCartItemsMap(): ITEMS', itemsList);

      let latest_index = 1;
      itemsList.map((item) => {
        for (let i = 0; i < item.quantity; i++) {
          const clonedItem = { ...item }; // Avoiding references and making bundle_order unique!
          this.saveItemInCart(clonedItem, latest_index);
          latest_index++;
        }
      });
    }

    getInternalCartItemsMap() {
      return Object.entries({ ...this._cartItems });
    }

    async fetchBundleBuilderCart() {
      const _this = this;
      return await fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((data) => {
          if (data?.items?.length > 0) {
            const bundleProducts = this.filterBundleProductsInCart(data.items);
            const orderedBundleProducts = this.sortBundleProducs(bundleProducts);

            if (orderedBundleProducts.length > 0) {
              _this.updateInternalCartItemsMap(orderedBundleProducts);
            }
          }

          _this.updateCartUI();
        });
    }

    addPromoLabelUI(tierNumber, label) {
      if (DEBUG) console.log('BB - addPromoLabelUI(): ADDING PROMO LABEL', tierNumber, label);
      const labelTemplate = this.LABEL_TEMPLATE.content.cloneNode(true);
      const labelContainer = labelTemplate.querySelector('[data-bb-promo-label]');

      if (!labelContainer) {
        if (DEBUG) console.warn('BB - addPromoLabelUI(): LABEL CONTAINER NOT FOUND!');
        return;
      }

      labelContainer.textContent = label;

      const skeletonEl = this.CART_ELEMENT.querySelector(`[data-bb-product-skeleton-order="${tierNumber}"]`);
      const productEl = this.CART_ELEMENT.querySelector(`[data-bb-product-order="${tierNumber}"]`);

      if (skeletonEl) {
        skeletonEl.appendChild(labelTemplate);
      }

      if (productEl) {
        productEl.appendChild(labelTemplate);
      }
    }

    addPromoLabelUIToCartProgressBar(tierNumber, label) {
      const progressLabels = this.CART_ELEMENT.querySelector('[data-bb-progress-labels]');
      // Add only on load, checking if there are already labels
      if (!progressLabels || progressLabels.querySelector(`[data-bb-progress-label="${tierNumber}"]`)) return;

      if (DEBUG)
        console.log('BB - addPromoLabelUIToCartProgressBar(): ADDING PROMO LABEL TO PROGRESS BAR', tierNumber, label);
      const progressBar = this.CART_ELEMENT.querySelector('.bundle-builder__cart-progress-bar');
      if (!progressBar) {
        if (DEBUG) console.warn('BB - addPromoLabelUIToCartProgressBar(): PROGRESS BAR NOT FOUND!');
        return;
      }

      const labelEl = document.createElement('li');
      labelEl.classList.add('bundle-builder__cart-progress-label');
      labelEl.setAttribute('data-bb-progress-label', tierNumber);
      labelEl.textContent = label;

      progressLabels.appendChild(labelEl);
    }

    addSkeletonsUI(currentCartItemsNumber) {
      if (DEBUG) console.log('BB - addSkeletonsUI(): ADDING SKELETONS FROM', currentCartItemsNumber);
      const startFrom = currentCartItemsNumber + 1;

      for (let i = startFrom; i <= this.MAX_SKELETONS_NUMBER; i++) {
        this.CART_ELEMENT.querySelector('.bundle-builder__cart-products').appendChild(this.SKELETONS_CACHE[i]);

        if (this.isMobile) {
          const mobileSkeleton = this.SKELETONS_CACHE[i].cloneNode(true);
          this.CART_WIDGET.querySelector('.bundle-builder__cart-products').appendChild(mobileSkeleton);
        }
      }
    }

    updateCartProgressUI(currentCartItemsNumber) {
      if (DEBUG)
        console.log('BB - updateCartProgressUI(): UPDATING PROGRESS BAR WITH', currentCartItemsNumber, 'ITEMS');
      const progressBar = this.CART_ELEMENT.querySelector('[data-bb-progress-bar-wrapper]');
      if (!progressBar) {
        if (DEBUG) console.warn('BB - updateCartProgressUI(): PROGRESS BAR NOT FOUND!');
        return;
      }

      const progressBarFill = progressBar.querySelector('[data-bb-progress]');
      const highestTierNumber = Math.max(...Object.keys(window.SF_BUNDLE_TIERS).map(Number));
      const progressPercentage = Math.min((currentCartItemsNumber / highestTierNumber) * 100, 100);
      progressBarFill.style.width = `${progressPercentage}%`;

      const presumedTier = this.findCurrentActiveTier(window.SF_BUNDLE_TIERS, currentCartItemsNumber);

      const presumedTierNumber = presumedTier?.value?.min_items || 0;
      const progressLabelsItems = progressBar.querySelectorAll('[data-bb-progress-label]');
      const currentProgressLabel = progressBar.querySelector('[data-bb-progress-label="' + presumedTierNumber + '"]');

      // Todo: Activate Labels based on current cart items number!!!
      if (presumedTierNumber) {
        if (currentProgressLabel) {
          currentProgressLabel.classList.add('bundle-builder__cart-progress-label--active');
          const nextProgressLabels = this.getNextSiblingsBySelector(currentProgressLabel, '[data-bb-progress-label]');
          nextProgressLabels.map((label) => {
            label.classList.remove('bundle-builder__cart-progress-label--active');
          });
        }
      } else {
        progressLabelsItems.forEach((label) => {
          label.classList.remove('bundle-builder__cart-progress-label--active');
        });
      }
    }

    formatPrice(priceInCents) {
      let price = String(parseFloat(priceInCents / 100).toFixed(2));
      price = price.replace('.', ',');
      price = `€ ${price}`;

      return price;
    }

    getActiveDiscountTier() {
      const itemsCount = this.getInternalCartItemsMap().length;

      const eligibleTiers = Object.values(window.SF_BUNDLE_TIERS).filter(
        (tier) => tier.type === 'discount' && tier.discount_percentage != null && tier.min_items <= itemsCount,
      );

      const activeTier = eligibleTiers.reduce(
        (max, tier) => (!max || tier.min_items > max.min_items ? tier : max),
        null,
      );

      return activeTier;
    }

    // Might slightly differ due to rounding issues
    applyActivePromos(priceInCents) {
      const activeTier = this.getActiveDiscountTier();
      const percDiscount = activeTier ? Number(activeTier.discount_percentage) : 0;

      const discountFactor = Math.min(percDiscount, 100);

      const discountedPriceInCents = Math.round((priceInCents * (100 - discountFactor)) / 100);
      return discountedPriceInCents;
    }

    filterHighestTierByPromoType(items) {
      return Object.values(
        items
          .filter((item) => item && item.type != null)
          .reduce((acc, item) => {
            const current = acc[item.type];

            if (!current || item.min_items > current.min_items) {
              acc[item.type] = item;
            }
            return acc;
          }, {}),
      );
    }

    resetFooterFreeGiftRows(activePromoLabels) {
      if (!activePromoLabels) return;

      const rows = Array.from(activePromoLabels.querySelectorAll('[data-bb-active-promo-label="free_gift"]'));

      rows.forEach((row) => {
        const keyEl = row.querySelector('[data-bb-key]');
        const valueEl = row.querySelector('[data-bb-value]');
        if (!valueEl) return;

        if (row.dataset.bbOriginalValue == null) row.dataset.bbOriginalValue = valueEl.innerHTML;
        if (keyEl && row.dataset.bbOriginalKey == null) row.dataset.bbOriginalKey = keyEl.innerHTML;

        if (keyEl && row.dataset.bbOriginalKey != null) keyEl.innerHTML = row.dataset.bbOriginalKey;

        valueEl.classList.remove('bundle-builder__cart-values');
        valueEl.innerHTML = row.dataset.bbOriginalValue;
      });
    }

    updateFooterFreeGiftRow(activePromoLabels, itemsCount) {
      if (!activePromoLabels || !window.SF_BUNDLE_TIERS) return;

      const tiers = Object.values(window.SF_BUNDLE_TIERS).filter(
        (tier) => tier && tier.type === 'free_gift' && tier.min_items != null && tier.min_items <= itemsCount,
      );

      if (!tiers.length) return;

      tiers.sort((a, b) => Number(a.min_items) - Number(b.min_items));

      const titles = [];
      const seen = new Set();

      tiers.forEach((tier) => {
        const row = activePromoLabels.querySelector(
          `[data-bb-active-promo-label="free_gift"][data-bb-active-promo-label-min-items="${tier.min_items}"]`,
        );
        const valueEl = row?.querySelector?.('[data-bb-value]');
        const title = valueEl ? valueEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!title) return;
        if (seen.has(title)) return;
        seen.add(title);
        titles.push(title);
      });

      // Always use the first free_gift row in DOM order as the display row
      const allRows = Array.from(activePromoLabels.querySelectorAll('[data-bb-active-promo-label="free_gift"]'));

      if (!allRows.length) return;

      const displayRow = allRows[0];

      allRows.forEach((row) => {
        if (row !== displayRow) row.setAttribute('disabled', true);
      });

      displayRow.removeAttribute('disabled');

      const keyEl = displayRow.querySelector('[data-bb-key]');
      if (keyEl) keyEl.textContent = 'Omaggio';

      const valueEl = displayRow.querySelector('[data-bb-value]');
      if (!valueEl) return;

      valueEl.classList.add('bundle-builder__cart-values');
      valueEl.innerHTML = '';

      titles.forEach((t) => {
        const s = document.createElement('span');
        s.className = 'bundle-builder__cart-value';
        s.textContent = t;
        valueEl.appendChild(s);
      });
    }

    updateCartFooterUI(cartItems) {
      const cartSubtotalValueElement = this.CART_ELEMENT.querySelector('[data-bb-subtotal] [data-bb-value]');
      const activePromoLabels = this.CART_ELEMENT.querySelector('[data-bb-active-promo-labels]');
      const widgetSubtotalValueElement = this.CART_WIDGET.querySelector(
        '[data-bb-widget-footer] [data-bb-subtotal-value]',
      );
      const widgetTotalValueElement = this.CART_WIDGET.querySelector('[data-bb-widget-footer] [data-bb-total-value]');
      const savingsRow = this.CART_ELEMENT.querySelector('[data-bb-savings]');
      const savingsValueEl = this.CART_ELEMENT.querySelector('[data-bb-savings-value]');

      if (cartSubtotalValueElement) {
        let cartTotalWithoutDiscounts = 0;
        cartItems.map(([itemId, item]) => {
          cartTotalWithoutDiscounts += item?.data ? item.data?.price : item.original_line_price;
        });

        const formattedTotalWithoutDiscounts = this.formatPrice(cartTotalWithoutDiscounts);
        widgetTotalValueElement.innerText = formattedTotalWithoutDiscounts;

        const discountedTotal = this.applyActivePromos(cartTotalWithoutDiscounts);
        const savings = Math.max(cartTotalWithoutDiscounts - discountedTotal, 0);

        const formattedDiscountedTotal = this.formatPrice(discountedTotal);
        widgetSubtotalValueElement.innerText = formattedDiscountedTotal;
        cartSubtotalValueElement.innerText = formattedDiscountedTotal;

        if (savingsRow && savingsValueEl) {
          if (savings > 0) {
            savingsRow.removeAttribute('hidden');
            savingsValueEl.innerText = `stai risparmiando ${this.formatPrice(savings)}`;
          } else {
            savingsRow.setAttribute('hidden', 'hidden');
            savingsValueEl.innerText = '';
          }
        }
      }

      if (activePromoLabels) {
        this.resetFooterFreeGiftRows(activePromoLabels);

        activePromoLabels.querySelectorAll('[data-bb-active-promo-label]')?.forEach((label) => {
          label.setAttribute('disabled', true);
        });

        const activePromoLabelsMap = Object.entries(window.SF_BUNDLE_TIERS)
          .map(([tierNumber, tier]) => {
            if (tier && tier.min_items <= cartItems.length) {
              return {
                type: tier.type,
                min_items: tier.min_items,
              };
            }
            return null;
          })
          .filter(Boolean);

        const highestPromoLabelsByType = this.filterHighestTierByPromoType(activePromoLabelsMap);

        highestPromoLabelsByType.forEach((activeLabel) => {
          if (!activeLabel) return;

          const { type, min_items } = activeLabel;

          activePromoLabels
            .querySelector(
              `[data-bb-active-promo-label="${type}"][data-bb-active-promo-label-min-items="${min_items}"]`,
            )
            ?.removeAttribute('disabled');
        });

        this.updateFooterFreeGiftRow(activePromoLabels, cartItems.length);
      }

      const itemsInCartMap = this.getInternalCartItemsMap();

      if (itemsInCartMap.length >= 1) {
        this.enableCartFlushButton();
      } else {
        this.disableCartFlushButton();
      }

      if (itemsInCartMap.length >= this.MIN_PROD) {
        this.enableCartSubmitButton();
      } else {
        this.disableCartSubmitButton();
      }
    }

    enableCartFlushButton() {
      if (this.FLUSH_BUTTON) this.FLUSH_BUTTON.removeAttribute('disabled');
    }

    disableCartFlushButton() {
      if (this.FLUSH_BUTTON) this.FLUSH_BUTTON.setAttribute('disabled', 'disabled');
    }

    enableCartSubmitButton() {
      if (this.CART_SUBMIT_BUTTON) this.CART_SUBMIT_BUTTON.removeAttribute('disabled');

      if (this.isMobile && this.CART_WIDGET_SUBMIT_BUTTON) {
        this.CART_WIDGET_SUBMIT_BUTTON.removeAttribute('disabled');
      }
    }

    disableCartSubmitButton() {
      if (this.CART_SUBMIT_BUTTON) this.CART_SUBMIT_BUTTON.setAttribute('disabled', 'disabled');

      if (this.isMobile && this.CART_WIDGET_SUBMIT_BUTTON) {
        this.CART_WIDGET_SUBMIT_BUTTON.setAttribute('disabled', 'disabled');
      }
    }

    flushCartUI() {
      this.CART_ELEMENT.querySelector('.bundle-builder__cart-products').innerHTML = '';
      if (this.isMobile) {
        this.CART_WIDGET.querySelector('.bundle-builder__cart-products').innerHTML = '';
      }
    }

    updateCartUI() {
      const _this = this;
      const internalCartItemsMap = _this.getInternalCartItemsMap();

      if (DEBUG) console.log('BB - updateCartUI(): UPDATING CART UI', internalCartItemsMap);

      this.flushCartUI();

      internalCartItemsMap.map(([itemId, item]) => {
        _this.updateProductInBundleBuilderCartUI(itemId, item);

        if (_this.isMobile) {
          _this.updateProductInBundleBuilderWidgetUI(itemId, item);
        }
      });

      _this.addSkeletonsUI(internalCartItemsMap.length);
      _this.updateCartProgressUI(internalCartItemsMap.length);

      if (!window.SF_BUNDLE_TIERS) return;

      Object.entries(window.SF_BUNDLE_TIERS).map(([tierNumber, tier]) => {
        _this.addPromoLabelUI(tierNumber, tier.label);
        _this.addPromoLabelUIToCartProgressBar(tierNumber, tier.label);
      });

      _this.updateCartFooterUI(internalCartItemsMap);

      if (_this.isMobile) {
        _this.updateWidgetScroll();
      }
    }

    updateWidgetScroll() {
      const _this = this;
      const widgetProductsContainer = _this.CART_WIDGET.querySelector('.bundle-builder__cart-body');
      const cartItemsLength = Object.values(_this._cartItems).length;

      if (widgetProductsContainer && cartItemsLength > 4) {
        const itemWidth = widgetProductsContainer.querySelector('.bundle-builder__cart-products li').offsetWidth;
        widgetProductsContainer.scrollTo({
          left: itemWidth * (cartItemsLength - 4),
          behavior: 'smooth',
        });
      }
    }

    _buildStepsCache() {
      const stepsElements = this.querySelectorAll('[data-bb-step-name]');
      this._stepsCache = Array.from(stepsElements).map((step) => ({
        el: step,
        name: step.getAttribute('data-bb-step-name'),
        counter: step.querySelector('[data-bb-step-counter]'),
        cards: Array.from(step.querySelectorAll('[data-bb-product-id]')),
      }));
    }

    updateProductGridUI() {
      // Use cached steps, rebuild only if not yet built
      if (!this._stepsCache) this._buildStepsCache();
      const stepsCache = this._stepsCache;
      const steps = {};
      const currentCartItemsEntries = Object.entries(this._cartItems);

      // Reset Steps Counter using cached references
      stepsCache.forEach(({ counter, cards }) => {
        if (counter && cards.length) {
          cards.forEach((card) => card.classList.remove('selected'));
          counter.setAttribute('disabled', true);
          counter.setAttribute('data-bb-step-counter', 0);
        }
      });

      // Looping Cart to count selected items
      currentCartItemsEntries.map(([itemId, item]) => {
        const variant_id = item.variant_id;
        const cardElement = this.querySelector(`[data-bb-product-id="${variant_id}"]`);

        if (cardElement) {
          cardElement.classList.add('selected');
          // Use cached step reference instead of closest() DOM traversal
          const cachedStep = stepsCache.find(({ cards }) => cards.includes(cardElement));
          if (cachedStep && cachedStep.counter) {
            steps[cachedStep.name] = (steps[cachedStep.name] || 0) + 1;
          }
        }

        this.updateProductLimit(cardElement, 0, false);
      });

      // Updating Steps Counter UI using cached references
      Object.entries(steps).map(([stepName, stepCounter]) => {
        const cachedStep = stepsCache.find(({ name }) => name === stepName);
        const counter = cachedStep?.counter;
        const counterNum = counter?.querySelector('[data-bb-step-counter-num]');

        if (counter && counterNum) {
          counterNum.setAttribute('data-bb-step-counter-num', stepCounter);
          counter.removeAttribute('disabled');
        }
      });

      if (this.MAX_PROD && currentCartItemsEntries.length >= this.MAX_PROD) {
        this.PRODUCT_GRID.setAttribute('disabled', true);

        if (this.CART_INTERACTIONS > 0) {
          this.SNACKBAR_STACK.show(this.SNACKBAR_STACK.setupMessage(null, 'max-bundle'), {
            type: 'max-bundle',
            duration: Infinity, // DEBUG: keep visible permanently
          });

          this.CART_SUBMIT_BUTTON?.dispatchEvent(
            new CustomEvent('bundleBuilder:maxReached', {
              bubbles: true,
              cancelable: true,
              detail: {
                maxBundleReached: true,
              },
            }),
          );
        }
      } else {
        this.PRODUCT_GRID.removeAttribute('disabled');
      }
    }

    async init() {
      // Verifica che il bundle builder sia attivo
      if (!window.SF_BUNDLE_TIERS) return;
      this.startLoading();

      // Wait for the cart to be ready ( thank you Shopify, great work! :) )
      await window.setTimeout(async () => {
        return await this.fetchBundleBuilderCart();
      }, 300);

      this.getBundleBuilderProducts();
      this.setupListeners();
      this.setupMobileListeners();
      this.updateProductGridUI();
      this.addStyleForWidget();

      this.stopLoading();
    }
  }

  customElements.define('bundle-builder', BundleBuilder);
})();
